import { Languages } from "../types";
import { getSettingsMedicalAreaDescriptions } from "./MedicalArea";
import { SettingsPagesDescriptions } from "./types";

export const getSettingsPagesDescriptions = (systemLang: Languages): SettingsPagesDescriptions => ({
    MEDICAL_AREA: getSettingsMedicalAreaDescriptions(systemLang),
})